import AppComponent from '../../mixins/app-component'

export default
{
    name: 'app-translate',

    mixins: [
        AppComponent
    ],

    props: {
        path: { type: Object, default: {} },
        params: { type: Object, default: null }
    },

    methods:
    {
        _getLocaleTranslation() {
            let v = this.path[this.$root.lang]

            if (this.params) {
                v = v.replace(':first', this.params.first).replace(':second', this.params.second).replace(':third', this.params.third)
            }

            return v
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-translate/script.js